import { FormControl, Select, MenuItem } from "@mui/material";
import {
    getRecentAcademicYears,
    formatAcademicYearLabel,
    ALL_ACADEMIC_YEARS,
} from "../../helper/AcademicYearHelper";
import { cyberColors, CYBER_FONT } from "../../styles/cyberTheme";

const selectSx = {
    minWidth: 140,
    fontFamily: CYBER_FONT,
    color: cyberColors.cyan,
    "& .MuiOutlinedInput-notchedOutline": {
        borderColor: cyberColors.purple.borderBold,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: cyberColors.cyanAlpha.subtle,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: cyberColors.cyan,
    },
    "& .MuiSvgIcon-root": {
        color: cyberColors.cyan,
    },
};

const menuProps = {
    PaperProps: {
        sx: {
            bgcolor: "rgba(10, 5, 30, 0.95)",
            border: `1px solid ${cyberColors.purple.borderBold}`,
            "& .MuiMenuItem-root": {
                fontFamily: CYBER_FONT,
                color: cyberColors.text.white,
                "&:hover": {
                    bgcolor: cyberColors.purple.faint,
                },
                "&.Mui-selected": {
                    bgcolor: cyberColors.purple.activeFill,
                    color: cyberColors.cyan,
                
                },
            },
        },
    },
};

export default function MemberAcademicYearSelect({
    value,
    onChange,
    years = getRecentAcademicYears(3),
    formatLabel = formatAcademicYearLabel,
    sx: sxProp,
}) {
    const yearOptions = years.includes(ALL_ACADEMIC_YEARS)
        ? years
        : [ALL_ACADEMIC_YEARS, ...years];

    return (
        <FormControl size="small" sx={{ ...selectSx, ...sxProp }}>
            <Select
                value={value}
                onChange={(e) => onChange(Number(e.target.value))}
                displayEmpty
                MenuProps={menuProps}
                sx={{
                    color: cyberColors.text.white,
                }}
            >
                {yearOptions.map((year) => (
                    <MenuItem key={year} value={year}>
                        {formatLabel(year)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
